import { type CampoEstraibileCSV } from '@framework/api-client/api/inquiries/schemas/campoEstraibileCSV.ts';
import { EnumCampoEstraibileCSVOrigineCampoCompilabile } from '@framework/api-client/api/inquiries/schemas/enumCampoEstraibileCSVOrigineCampoCompilabile.ts';

export type ExportFileField = CampoEstraibileCSV;

export type ExportFileType = 'geojson' | 'csv' | 'xlsx' | 'pdf';
// I form admin per la configurazione dei campi default trattano
// tutto ciò che non è 'geojson' come CSV: 'pdf' va escluso perché
// verrebbe gestito in modo silenziosamente errato.
export type ExportFieldConfigFileType = Exclude<ExportFileType, 'pdf'>;
export type ExportFileEntity =
  | 'procedimenti'
  | 'attività'
  | 'richieste'
  | 'scadenze'
  | 'albi';

export type ExtractableFileFieldOrigin =
  EnumCampoEstraibileCSVOrigineCampoCompilabile;
export const ExtractableFileFieldOrigins =
  EnumCampoEstraibileCSVOrigineCampoCompilabile;

export enum TemplateSaveActionEnum {
  NO_SAVE = 'no_save',
  UPDATE_TEMPLATE = 'update_template',
  NEW_TEMPLATE = 'new_template',
}
